import SignInComponent from '../components/SignIn';

export default function SignIn() {
  return (
    <section className={'login-section'}>
      <h1 className={'logo-title'}>
        <i className={'logo'} />
        <span>스마트농장</span>
      </h1>
      <SignInComponent />
    </section>
  );
}
